module.exports = __webpack_public_path__ + "img/icon-3.7ac52919.png";